import * as React from 'react';
import { Label, Input } from './InputField.styles';

interface InputFieldProps {
  label: string;
  name: string;
  value: string | number;
  type?: string;
  maxLenght?: string;
  placeholder?: string;
  disabled?: boolean;
  maxDate?: string;
  minDate?: string;
  pattern?: string;
  required?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<InputFieldProps> = (props) => {
  const fieldId = `id_${props.name}`;

  return (
    <Label htmlFor={fieldId}>
      {props.label}
      <Input
        type={props.type}
        id={fieldId}
        name={props.name}
        maxLength={(props.maxLenght != null ? (parseInt(props.maxLenght)) : 500)}
        placeholder={props.placeholder}
        disabled={props.disabled}
        required={props.required}
        value={props.value}
        onChange={props.onChange}
        max={props.maxDate}
        min={props.minDate}
        pattern={props.pattern}
      />
    </Label>
  );
};

InputField.defaultProps = {
  type: 'text',
  placeholder: '',
};

export default InputField;
